import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useGoogleAnalytics from '../../CustomHooks/useGoogleAnalytics';
import AddNewOptionGroup__View from './AddOrEditOptionGroup__View';
import useFetch from '../../CustomHooks/useFetch';
import useCustomerSettings from 'CustomHooks/useCustomerSettings';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';


export default function AddOrEditOptionGroup(props) {
    const globalContext = useContext(GlobalContext);
    const [optionGroupName, setOptionGroupName] = useState('');
    const [optionGroupNameError, setOptionGroupNameError] = useState('');
    const [from, setFrom] = useState(0);
    const [to, setTo] = useState(20);
    const [allowMultiplesOfAnOption, setAllowMultiplesOfAnOption] = useState(true);
    const [options, setOptions] = useState([{ optionName: '', optionPrice: 0, optionNameError: '', optionPriceError: '' },]);
    const setGAPath = useGoogleAnalytics();
    const [addOptionGroupHookResponse, addOptionGroupHook] = useFetch();
    const [getOptionGroupHookResponse, getOptionGroupHook] = useFetch();
    const [updateOptionGroupHookResponse, updateOptionGroupHook] = useFetch();
    const getCustomerSettingsHookResponse = useCustomerSettings();
    const [currency, setCurrency] = useState('');
    const [translateGui] = useGuiTranslations();

    useEffect (
        () => {
            if(getCustomerSettingsHookResponse.currency != null) {
                setCurrency(getCustomerSettingsHookResponse.currency.toUpperCase());
            }
            //console.log(getCustomerSettingsHookResponse);
        },[getCustomerSettingsHookResponse]
    )

    const validate = () => {
        if (optionGroupName == '') {
            setOptionGroupNameError(capitalizeFirstLetter(translateGui(54)))
            return false;
        }
        else {
            setOptionGroupNameError('')
        }

        let newOptions = [...options];
        let optionResult = true;
        options.map(
            (option, index) => {
                if (option.optionName == '') {
                    newOptions[index].optionNameError = capitalizeFirstLetter(translateGui(55));
                    optionResult =  false;
                }
                else {
                    newOptions[index].optionNameError = '';
                }
                
                console.log(option.optionPrice);
                if ( option.optionPrice.length != undefined && option.optionPrice.length == 0 ) {
                    newOptions[index].optionPriceError = capitalizeFirstLetter(translateGui(56));
                    optionResult =  false;
                }
                else {
                    newOptions[index].optionPriceError = '';
                }
            }
        )
        setOptions(newOptions);
        if(!optionResult) {
            console.log('falsemus');
            return false;
        }

        return true;
    }
    const submit = () => {
        if (!validate())
            return;

        if (props.optionGroupId == 0) {
            addOptionGroup();
        }
        else {
            updateOptionGroup();
        }
    }

    const updateOptionGroup = () => {
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
        updateOptionGroupHook(
            {
                url: '/admin/food-options/' + props.optionGroupId,
                method: 'PUT',
                postData: {
                    "optionGroupName": optionGroupName,
                    "from": from,
                    "to": to,
                    "addMultiplesOfItem": allowMultiplesOfAnOption,
                    "options": options.map(
                        (option, index) => { return { optionId: index + 1, optionName: option.optionName, optionPrice: option.optionPrice } }),
                    "isAvailable": true
                },
                addTokenHeader: true,
            }
        )
    }

    useEffect(
        () => {
            if (updateOptionGroupHookResponse.id != null) {
                props.closeForm();
            }
        }, [updateOptionGroupHookResponse]
    )

    useEffect(
        () => {
            if (addOptionGroupHookResponse.id != null ) {
                //props.closeForm();
                if(props.setSelectedOptionGroupIdAndCloseOptionGroupForm){
                    props.setSelectedOptionGroupIdAndCloseOptionGroupForm(addOptionGroupHookResponse.id);
                }
                else {
                    props.closeForm();
                }
            }
        }, [addOptionGroupHookResponse]
    )

    const updateOption = (index, optionAttr, value) => {
        let newOptions = [...options];
        newOptions[index][optionAttr] = value;
        setOptions(newOptions);
    }

    const deleteOption = (index) => {
        let newOptions = [...options];
        newOptions.splice(index, 1);
        setOptions(newOptions);
    }

    const addNewOptionRow = () => {
        let newOptions = [...options];
        newOptions.push({ optionName: '', optionPrice: 0, optionNameError: '', optionPriceError: '' });
        setOptions(newOptions);
    }

    useEffect(
        () => {
            if (props.optionGroupId > 0) {
                getOptionGroupHook(
                    {
                        url: '/admin/food-options/' + props.optionGroupId,
                        method: 'GET',
                        addTokenHeader: true,
                        postData: null,
                    }
                )
            }

        }, []
    )

    useEffect(
        () => {
            if (getOptionGroupHookResponse.id != null) {
                setOptionGroupName(getOptionGroupHookResponse.optionGroupName);
                setFrom(getOptionGroupHookResponse.from);
                setTo(getOptionGroupHookResponse.to);
                setAllowMultiplesOfAnOption(getOptionGroupHookResponse.addMultiplesOfItem);
                setOptions(getOptionGroupHookResponse.options.map(
                    option => { return { optionName: option.optionName, optionPrice: option.optionPrice, optionNameError: '', optionPriceError: '', } }
                ))
            }
        }, [getOptionGroupHookResponse]
    )

    const addOptionGroup = () => {
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: 'Adding option group...', showButton: false } });
        addOptionGroupHook(
            {
                url: '/admin/food-options',
                method: 'POST',
                addTokenHeader: true,
                postData: {
                    "optionGroupName": optionGroupName,
                    "from": from,
                    "to": to,
                    "addMultiplesOfItem": allowMultiplesOfAnOption,
                    "options": options.map(
                        (option, index) => { return { optionId: index + 1, optionName: option.optionName, optionPrice: option.optionPrice } }),
                    "isAvailable": true
                },
            }
        )
    }

    useEffect(
        () => {
            setGAPath('/AddNewOptionGroup');
        }, []
    )


    return (
        <AddNewOptionGroup__View
            optionGroupName={optionGroupName}
            setOptionGroupName={setOptionGroupName}
            updateOption={updateOption}
            deleteOption={deleteOption}
            setOptionGroupNameError={setOptionGroupNameError}
            optionGroupNameError={optionGroupNameError}
            from={from}
            to={to}
            setFrom={setFrom}
            setTo={setTo}
            setOptions={setOptions}
            options={options}
            allowMultiplesOfAnOption={allowMultiplesOfAnOption}
            setAllowMultiplesOfAnOption={setAllowMultiplesOfAnOption}
            submit={submit}
            addNewOptionRow={addNewOptionRow}
            closeForm={props.closeForm}
            currency={currency}
        />
    )
}